<div *ngIf="loading" class="loading-overlay">
  <div class="loading-container">
    <!-- Document Scan Animation -->
    <ng-container *ngIf="loadingType === 'document-scan'; else defaultLoading">
      <div class="scan-doc-animation">
        <div class="scan-doc-wrapper">
          <img 
            [src]="scanState === 'pending' ? 'assets/img/icons/charge.png' : (scanState === 'success' ? 'assets/img/icons/chek.png' : 'assets/img/icons/nochek.png')"
            [alt]="scanState === 'pending' ? 'Cargando' : (scanState === 'success' ? 'Completado' : 'Error')"
            class="scan-doc-img"
          />
          <div *ngIf="scanState === 'pending'" class="scan-line-infinite"></div>
        </div>
        <div class="scan-doc-message">
          <p>{{ loadingMessage }}</p>
        </div>
      </div>
    </ng-container>
    <ng-template #defaultLoading>
      <div class="loading-spinner">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div class="loading-message">
        <p>{{ loadingMessage }}</p>
      </div>
      <div *ngIf="showProgress" class="loading-progress">
        <div class="progress">
          <div 
            class="progress-bar progress-bar-striped progress-bar-animated" 
            [ngClass]="{
              'bg-primary': loadingType === 'default',
              'bg-success': loadingType === 'process',
              'bg-info': loadingType === 'download',
              'bg-warning': loadingType === 'upload'
            }"
            [style.width.%]="loadingProgress"
            role="progressbar" 
            [attr.aria-valuenow]="loadingProgress" 
            aria-valuemin="0" 
            aria-valuemax="100">
            {{ loadingProgress }}%
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
